export const AU_TFN_TAB_KEY = 'au_tfn' as const;

export const FORMIK_AU_TFN_FIELD_IDS = {
  TFN: 'au_tfn',
  TFN_EXEMPTION: 'au_tfn_exemption',
  EMPLOYMENT_BASIS: 'au_employment_basis',
  RESIDENCY_STATUS: 'au_residency_status',
  HAS_TAX_FREE_THRESHOLD: 'au_has_tax_free_threshold',
  HAS_HELP_DEBT: 'au_has_help_debt',
  TFN_DOCUMENT_ID: 'au_tfn_document_id',
  REMOVE_TFN_DOCUMENT: 'remove_au_tfn_document',
} as const;
